export enum OfferLabelsToColorsEnum {
  TEST = "warning is-light",
  EXCLUSIVE = "purple is-light",
  NO_TRAFFIC = "danger is-light",
  RESALE = "info is-light",
  IS_NEW = "info",
  EMPTY = "info is-light",
}